export interface IDiscount {
    getName(): string
    getValue(): number | string
}

class Discount implements IDiscount {
    protected name: string
    protected value: number | string

    constructor(name: string, value: number | string) {
        this.name = name
        this.value = value
    }

    public getName(): string {
        return this.name
    }
    public getValue(): number | string {
        return this.value
    }
}

export default Discount